import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-red"
}
const _hoisted_2 = {
  key: 1,
  class: "warning--text"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 0,
  class: "text-red"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_virtual_scroll = _resolveComponent("v-virtual-scroll")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_UploadDocuments = _resolveComponent("UploadDocuments")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn_primary, {
                block: "",
                style: {"white-space":"nowrap","text-overflow":"ellipsis"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openDialogEbic()))
              }, {
                default: _withCtx(() => _cache[24] || (_cache[24] = [
                  _createTextVNode("Ajouter")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "10",
            class: "d-flex align-center justify-end px-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_tooltip, { location: "bottom" }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn_icon, _mergeProps({
                    icon: "$fa-sync-alt",
                    elevation: "0",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openDialogBankTransactionAPIs())),
                    loading: _ctx.loadingUpdateAPI
                  }, props), null, 16, ["loading"])
                ]),
                default: _withCtx(() => [
                  _cache[25] || (_cache[25] = _createElementVNode("span", null, "Actualiser les connexions", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_oss_dialog, {
                modelValue: _ctx.dialogBankTransactionAPIs,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dialogBankTransactionAPIs) = $event)),
                title: "Définir la date de début d'import",
                "previous-disabled": _ctx.refreshEbicStep === 'main',
                hideValid: !(_ctx.refreshEbicStep !== 'main'),
                onClose: _cache[10] || (_cache[10] = ($event: any) => {
                        _ctx.dialogBankTransactionAPIs = false;
                        _ctx.resetRefreshEbicDialog();
                    }),
                onPrevious: _cache[11] || (_cache[11] = ($event: any) => (_ctx.resetRefreshEbicDialog())),
                onValid: _cache[12] || (_cache[12] = ($event: any) => (_ctx.validRefreshEbics())),
                width: "50vw"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window, {
                    modelValue: _ctx.refreshEbicStep,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.refreshEbicStep) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_component_v_window_item, {
                        key: 0,
                        value: 'main'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, {
                            subheader: "",
                            lines: "two"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, {
                                class: _normalizeClass(
                                        !_ctx.$vuetify.display.mobile
                                            ? 'mb-2 oss-list-item'
                                            : 'mb-2 px-2 oss-list-item'
                                    ),
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.refreshEbicStep = 'updateJDC'))
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_btn_icon, { icon: "$chevron_right" })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[26] || (_cache[26] = [
                                      _createTextVNode("JeDéclare.com")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => _cache[27] || (_cache[27] = [
                                      _createTextVNode("Forcer la mise a jour de JeDéclare.com")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class"]),
                              _createVNode(_component_v_list_item, {
                                class: _normalizeClass(
                                        !_ctx.$vuetify.display.mobile
                                            ? 'mb-2 oss-list-item'
                                            : 'mb-2 px-2 oss-list-item'
                                    ),
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.refreshEbicStep = 'updateSoBank'))
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_btn_icon, { icon: "$chevron_right" })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[28] || (_cache[28] = [
                                      _createTextVNode("SoBank")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => _cache[29] || (_cache[29] = [
                                      _createTextVNode("Forcer la mise a jour de Sobank")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class"]),
                              _createVNode(_component_v_list_item, {
                                class: _normalizeClass(
                                        !_ctx.$vuetify.display.mobile
                                            ? 'mb-2 oss-list-item'
                                            : 'mb-2 px-2 oss-list-item'
                                    ),
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.refreshEbicStep = 'refreshImports'))
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_btn_icon, { icon: "$chevron_right" })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[30] || (_cache[30] = [
                                      _createTextVNode("Actualiser les imports")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => _cache[31] || (_cache[31] = [
                                      _createTextVNode("Actualiser les imports EBICs existants")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })),
                      (_openBlock(), _createBlock(_component_v_window_item, {
                        key: 1,
                        value: 'refreshImports'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                class: "py-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_oss_date_picker_filled, {
                                    modelValue: _ctx.dateStart,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dateStart) = $event)),
                                    label: "Date de début",
                                    "min-date": _ctx.minDateRefreshEbics,
                                    "max-date": _ctx.maxDateRefreshEbics
                                  }, null, 8, ["modelValue", "min-date", "max-date"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })),
                      (_openBlock(), _createBlock(_component_v_window_item, {
                        key: 2,
                        value: 'updateJDC'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                class: "py-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_oss_date_picker_filled, {
                                    modelValue: _ctx.dateStart,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dateStart) = $event)),
                                    label: "Date de début",
                                    "min-date": _ctx.minDateRefreshEbics,
                                    "max-date": _ctx.maxDateRefreshEbics
                                  }, null, 8, ["modelValue", "min-date", "max-date"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })),
                      (_openBlock(), _createBlock(_component_v_window_item, {
                        key: 3,
                        value: 'updateSoBank'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                class: "py-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_oss_date_picker_filled, {
                                    modelValue: _ctx.dateStart,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dateStart) = $event)),
                                    label: "Date de début",
                                    "min-date": _ctx.minDateRefreshEbics,
                                    "max-date": _ctx.maxDateRefreshEbics
                                  }, null, 8, ["modelValue", "min-date", "max-date"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue", "previous-disabled", "hideValid"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-center pt-3",
        style: _normalizeStyle('max-height:' + _ctx.maxHeight + ';' + 'overflow:auto')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "d-flex justify-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "default_card_wm",
                elevation: "0",
                style: {"width":"inherit"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list, { flat: "" }, {
                    default: _withCtx(() => [
                      (_ctx.accountingItemImports && _ctx.accountingItemImports.length)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_v_list_item, { class: "pb-3" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "3",
                                      class: "d-flex align-center font-weight-bold"
                                    }, {
                                      default: _withCtx(() => _cache[32] || (_cache[32] = [
                                        _createTextVNode(" Nom ")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "2",
                                      class: "d-flex align-center justify-center font-weight-bold"
                                    }, {
                                      default: _withCtx(() => _cache[33] || (_cache[33] = [
                                        _createTextVNode(" Date d'importation du fichier ")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "2",
                                      class: "d-flex align-center justify-center font-weight-bold"
                                    }, {
                                      default: _withCtx(() => _cache[34] || (_cache[34] = [
                                        _createTextVNode(" Dernière mise à jour dans bobbee ")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "2",
                                      class: "d-flex align-center justify-center font-weight-bold"
                                    }, {
                                      default: _withCtx(() => _cache[35] || (_cache[35] = [
                                        _createTextVNode(" Statut ")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "2",
                                      class: "d-flex align-center font-weight-bold"
                                    }, {
                                      default: _withCtx(() => _cache[36] || (_cache[36] = [
                                        _createTextVNode(" Origine ")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "1",
                                      class: "d-flex align-center justify-center font-weight-bold"
                                    }, {
                                      default: _withCtx(() => _cache[37] || (_cache[37] = [
                                        _createTextVNode(" Action ")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_virtual_scroll, {
                              bench: "5",
                              items: _ctx.accountingItemImports,
                              class: "striped"
                            }, {
                              default: _withCtx(({ item, index }) => [
                                (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: index,
                                  class: "pb-3"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "3",
                                          class: "d-flex align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.getTitle(item)), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          cols: "2",
                                          class: "d-flex align-center justify-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.formatDate(item.createdAt)), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          cols: "2",
                                          class: "d-flex align-center justify-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.formatDate(item.updatedAt)), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          cols: "2",
                                          class: "d-flex align-center px-5"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, {
                                                  cols: "12",
                                                  class: "d-flex align-center justify-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_chip, {
                                                      label: "",
                                                      color: _ctx.statusColor(item.status),
                                                      size: "x-small"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t(
                                                                    `accountingItemImport.status.${item.status}`,
                                                                )), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["color"])
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_col, { cols: "12" })
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          cols: "2",
                                          class: "d-flex align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.getImportType(item)), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          cols: "1",
                                          class: "d-flex justify-space-around"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn_icon, {
                                              icon: "$fa-redo-alt",
                                              size: "small",
                                              disabled: 
                                                        !item.status.startsWith('IMPORTED') &&
                                                        !item.status.startsWith('REJECTED')
                                                    ,
                                              onClick: ($event: any) => (_ctx.displayBankTransactions(item))
                                            }, null, 8, ["disabled", "onClick"]),
                                            (item.file && item.file.id)
                                              ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                  key: 0,
                                                  icon: "$oss-download",
                                                  size: "small",
                                                  onClick: ($event: any) => (_ctx.downloadFile(item))
                                                }, null, 8, ["onClick"]))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_v_menu, { "offset-y": "" }, {
                                              activator: _withCtx(({ props }) => [
                                                _createVNode(_component_v_btn_icon, _mergeProps({
                                                  icon: "$dots_vertical",
                                                  size: "small"
                                                }, props), null, 16)
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item, {
                                                      title: 'Rejeter',
                                                      onClick: ($event: any) => {
                                                                _ctx.toDeleteAccountingItemImportId =
                                                                    item.id;
                                                                _ctx.rejectAccountingItemImportDialog = true;
                                                            }
                                                    }, {
                                                      append: _withCtx(() => [
                                                        _createVNode(_component_v_btn, {
                                                          icon: "$warning",
                                                          size: "x-small",
                                                          class: "ml-1"
                                                        })
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick"])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            (_ctx.getAdvance(item) !== 100)
                                              ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                                                  key: 0,
                                                  indeterminate: !_ctx.getAdvance(item),
                                                  rounded: "",
                                                  "model-value": _ctx.getAdvance(item)
                                                }, null, 8, ["indeterminate", "model-value"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              ]),
                              _: 1
                            }, 8, ["items"])
                          ], 64))
                        : (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 1,
                            class: "oss-list-item py-3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    class: "d-flex align-center justify-center pb-4"
                                  }, {
                                    default: _withCtx(() => _cache[38] || (_cache[38] = [
                                      _createTextVNode(" Aucun import n'a été trouvés ")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    class: "d-flex align-center justify-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        rounded: "",
                                        elevation: "0",
                                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.openDialogEbic())),
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => _cache[39] || (_cache[39] = [
                                          _createTextVNode(" Créer un import EBICS ")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["style"]),
      (_ctx.ebicsDialog)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 0,
            modelValue: _ctx.ebicsDialog,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.ebicsDialog) = $event)),
            title: "Import EBICS",
            hideValid: _ctx.windowStep !== 1,
            loading: _ctx.loading,
            onValid: _cache[18] || (_cache[18] = ($event: any) => (_ctx.valid())),
            onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.closeEbicsDialog())),
            width: "60vw"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_window, {
                        modelValue: _ctx.windowStep,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.windowStep) = $event)),
                        touchless: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_window_item, { value: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.error) + " ", 1),
                                  _createVNode(_component_UploadDocuments, {
                                    showFirstPrevious: true,
                                    companyId: _ctx.company.id,
                                    documentType: 'BANK_STATEMENT',
                                    inExtensions: ['dat'],
                                    multiple: false,
                                    freeTag: false,
                                    gDrive: false,
                                    maxSize: 0,
                                    onFileInput: _cache[14] || (_cache[14] = ($event: any) => (_ctx.readFile($event)))
                                  }, null, 8, ["companyId"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_window_item, { value: 1 }, {
                            default: _withCtx(() => [
                              (!_ctx.bankAccounts || !_ctx.bankAccounts.length)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_component_v_card_title, { class: "title font-weight-regular justify-space-between" }, {
                                      default: _withCtx(() => _cache[40] || (_cache[40] = [
                                        _createElementVNode("span", null, "Chargement en cours...", -1)
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_card_text, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              class: "d-flex align-center justify-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_progress_linear, {
                                                  indeterminate: "",
                                                  rounded: ""
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createVNode(_component_v_card_title, { class: "title font-weight-regular justify-space-between pt-0 mt-0" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", null, "Comptes bancaires : " + _toDisplayString(_ctx.bankAccounts
                                                ? _ctx.foundBankAccounts + "/" + _ctx.bankAccounts.length
                                                : _ctx.foundBankAccounts), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_card_text, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "12" }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", null, [
                                                  _createVNode(_component_v_icon, {
                                                    color: "secondary",
                                                    size: "x-small"
                                                  }, {
                                                    default: _withCtx(() => _cache[41] || (_cache[41] = [
                                                      _createTextVNode("$fa-check")
                                                    ])),
                                                    _: 1
                                                  }),
                                                  _createTextVNode(" Mouvements bancaires importés: " + _toDisplayString(_ctx.totalBankTransactionImported) + "/" + _toDisplayString(_ctx.totalBankTransactionCount), 1)
                                                ]),
                                                (_ctx.totalErrors)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                                      _createVNode(_component_v_icon, {
                                                        color: "error",
                                                        size: "x-small"
                                                      }, {
                                                        default: _withCtx(() => _cache[42] || (_cache[42] = [
                                                          _createTextVNode("$fa-exclamation-triangle")
                                                        ])),
                                                        _: 1
                                                      }),
                                                      _createTextVNode(" Mouvements bancaires en erreur: " + _toDisplayString(_ctx.totalErrors) + "/" + _toDisplayString(_ctx.totalBankTransactionCount), 1)
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                (_ctx.totalWarnings)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                                      _createVNode(_component_v_icon, {
                                                        color: "warning",
                                                        size: "x-small"
                                                      }, {
                                                        default: _withCtx(() => _cache[43] || (_cache[43] = [
                                                          _createTextVNode("$fa-exclamation-triangle")
                                                        ])),
                                                        _: 1
                                                      }),
                                                      _createTextVNode(" Mouvements bancaires non importés: " + _toDisplayString(_ctx.totalWarnings) + "/" + _toDisplayString(_ctx.totalBankTransactionCount), 1)
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, { cols: "12" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_select_filled, {
                                                  modelValue: _ctx.filterBankAccount,
                                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.filterBankAccount) = $event)),
                                                  items: _ctx.filteredBankAccountsList,
                                                  "item-value": "value",
                                                  label: "Filtrer",
                                                  class: "mt-3",
                                                  outlined: "",
                                                  "hide-details": "",
                                                  density: "compact",
                                                  "item-title": (item) => item.text
                                                }, null, 8, ["modelValue", "items", "item-title"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, { cols: "12" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list, {
                                                  style: {"background-color":"transparent"},
                                                  lines: "two"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_virtual_scroll, {
                                                      "item-height": 100,
                                                      items: _ctx.filteredBankAccounts,
                                                      height: "450",
                                                      class: "py-3",
                                                      bench: "2"
                                                    }, {
                                                      default: _withCtx(({ item }) => [
                                                        (_openBlock(), _createBlock(_component_v_list_item, {
                                                          key: item.key,
                                                          class: _normalizeClass(_ctx.getItemClass(item)),
                                                          height: "100px",
                                                          active: false,
                                                          link: false
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_list_item_title, { class: "pb-1" }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(item.partialIban) + " - Solde = " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                        item.balance.balance,
                                                                        undefined,
                                                                    )), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1024),
                                                            _createVNode(_component_v_list_item_subtitle, null, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_icon, {
                                                                  size: "x-small",
                                                                  class: "mr-2"
                                                                }, {
                                                                  default: _withCtx(() => _cache[44] || (_cache[44] = [
                                                                    _createTextVNode("$fa-university")
                                                                  ])),
                                                                  _: 1
                                                                }),
                                                                _createTextVNode(" " + _toDisplayString(_ctx.getDBBAText(item)), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1024),
                                                            (
                                                                    item &&
                                                                    item.errors &&
                                                                    item.errors.length
                                                                )
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                                                  _createVNode(_component_v_icon, {
                                                                    class: "mr-2",
                                                                    color: "red",
                                                                    size: "x-small"
                                                                  }, {
                                                                    default: _withCtx(() => _cache[45] || (_cache[45] = [
                                                                      _createTextVNode("$report_problem")
                                                                    ])),
                                                                    _: 1
                                                                  }),
                                                                  _createTextVNode(" " + _toDisplayString(_ctx.getErrors(item)), 1)
                                                                ]))
                                                              : _createCommentVNode("", true),
                                                            (
                                                                    item &&
                                                                    item.warnings &&
                                                                    item.warnings.length
                                                                )
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                                  _createVNode(_component_v_icon, {
                                                                    class: "mr-2",
                                                                    color: "orange",
                                                                    size: "x-small"
                                                                  }, {
                                                                    default: _withCtx(() => _cache[46] || (_cache[46] = [
                                                                      _createTextVNode("$report_problem")
                                                                    ])),
                                                                    _: 1
                                                                  }),
                                                                  _createTextVNode(" " + _toDisplayString(_ctx.getWarnings(item)), 1)
                                                                ]))
                                                              : _createCommentVNode("", true),
                                                            (
                                                                    _ctx.getItemClass(item) ===
                                                                        'oss-list-item-selected-inactive' ||
                                                                    _ctx.getItemClass(item) ===
                                                                        'oss-list-item-selected'
                                                                )
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                                                  (
                                                                            (item.btCount || 0) !==
                                                                            item.bankTransactionCount
                                                                        )
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                                                        _createVNode(_component_v_icon, {
                                                                          color: "error",
                                                                          size: "x-small"
                                                                        }, {
                                                                          default: _withCtx(() => _cache[47] || (_cache[47] = [
                                                                            _createTextVNode("$fa-exclamation-triangle")
                                                                          ])),
                                                                          _: 1
                                                                        }),
                                                                        _createTextVNode(" " + _toDisplayString(item.btCount || 0) + " / " + _toDisplayString(item.bankTransactionCount ||
                                                                                0) + " mouvements bancaires importés ", 1)
                                                                      ]))
                                                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                        _createVNode(_component_v_icon, {
                                                                          color: "secondary",
                                                                          size: "x-small"
                                                                        }, {
                                                                          default: _withCtx(() => _cache[48] || (_cache[48] = [
                                                                            _createTextVNode("$fa-check")
                                                                          ])),
                                                                          _: 1
                                                                        }),
                                                                        _createTextVNode(" " + _toDisplayString(item.btCount || 0) + " / " + _toDisplayString(item.bankTransactionCount ||
                                                                            0) + " mouvements bancaires importés ", 1)
                                                                      ], 64))
                                                                ]))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["class"]))
                                                      ]),
                                                      _: 1
                                                    }, 8, ["items"])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ], 64))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_window_item, { value: 2 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_title, { class: "title font-weight-regular justify-space-between" }, {
                                default: _withCtx(() => _cache[49] || (_cache[49] = [
                                  _createTextVNode(" Importé ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "hideValid", "loading"]))
        : _createCommentVNode("", true),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.rejectAccountingItemImportDialog,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.rejectAccountingItemImportDialog) = $event)),
        title: "Rejeter l'import EBICS",
        onValid: _cache[21] || (_cache[21] = ($event: any) => (_ctx.rejectAccountingItemImport())),
        validLoading: _ctx.deleteAccountingItemImportLoading,
        width: "850px"
      }, {
        default: _withCtx(() => _cache[50] || (_cache[50] = [
          _createElementVNode("div", { class: "text-center" }, [
            _createElementVNode("h4", null, "Êtes-vous sûr(e) de vouloir rejeter cet import EBIC ?"),
            _createElementVNode("div", null, " Il ne sera pas supprimé, et vous pourrez toujours récupérer plus tard les mouvements bancaires depuis cette page "),
            _createElementVNode("div", null, " Attention : Par contre toutes les manipulations effectuées sur les mouvements bancaires (Lettrages...) depuis leur création seront définitivement perdues ")
          ], -1)
        ])),
        _: 1
      }, 8, ["modelValue", "validLoading"]),
      _createVNode(_component_v_snackbar, {
        modelValue: _ctx.snackbar,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.snackbar) = $event))
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.snackbar = false)),
            variant: "text"
          }, {
            default: _withCtx(() => _cache[51] || (_cache[51] = [
              _createTextVNode(" Close ")
            ])),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _cache[52] || (_cache[52] = _createTextVNode(" Mise a jour des comptes bancaires en cours. L'opération peut prendre du temps. Merci de patienter "))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}